var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.667 15.9987V22.452C58.667 26.6654 56.0003 29.332 51.787 29.332H42.667V10.692C42.667 7.73203 45.0937 5.33203 48.0537 5.33203C50.9603 5.3587 53.627 6.53203 55.547 8.45203C57.467 10.3987 58.667 13.0654 58.667 15.9987Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.33301 18.6654V55.9987C5.33301 58.212 7.83969 59.4654 9.59969 58.132L14.1597 54.7187C15.2263 53.9187 16.7197 54.0254 17.6797 54.9854L22.1063 59.4387C23.1463 60.4787 24.853 60.4787 25.893 59.4387L30.373 54.9587C31.3063 54.0254 32.7997 53.9187 33.8397 54.7187L38.3997 58.132C40.1597 59.4387 42.6663 58.1854 42.6663 55.9987V10.6654C42.6663 7.73203 45.0663 5.33203 47.9997 5.33203H18.6663H15.9997C7.99967 5.33203 5.33301 10.1054 5.33301 15.9987V18.6654Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3337 24.6654H26.0003V19.332C26.0003 18.2387 25.0937 17.332 24.0003 17.332C22.907 17.332 22.0003 18.2387 22.0003 19.332V24.6654H16.667C15.5737 24.6654 14.667 25.572 14.667 26.6654C14.667 27.7587 15.5737 28.6654 16.667 28.6654H22.0003V33.9987C22.0003 35.092 22.907 35.9987 24.0003 35.9987C25.0937 35.9987 26.0003 35.092 26.0003 33.9987V28.6654H31.3337C32.427 28.6654 33.3337 27.7587 33.3337 26.6654C33.3337 25.572 32.427 24.6654 31.3337 24.6654Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/emptyState.8175acd769fd079740af35584e22b4ed.svg";
export { ForwardRef as ReactComponent };